import React from "react";
import "./Gallery.css";

const images = [
  { src: "hero1.jpg", name: "Project Alpha" },
  { src: "hero2.jpeg", name: "Project Beta" },
  { src: "hero4.jpg", name: "Project Gamma" },
  { src: "hero1.jpg", name: "Project Delta" },
  { src: "hero2.jpeg", name: "Project Epsilon" },
  { src: "hero4.jpg", name: "Project Zeta" },
];

const Gallery = () => {
  return (
    <>
      {/* Hero Section */}
      <section
        className="gallery-hero-section"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + "/images/hero1.jpg"})`,
        }}
      >
        <div className="overlay"></div>
        <div className="gallery-hero-content">
          <h1>Our Gallery</h1>
          <p>Check out some of our amazing projects</p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="gallery-grid">
        {images.map((img, index) => (
          <div className="gallery-item" key={index}>
            <img src={process.env.PUBLIC_URL + "/images/" + img.src} alt={img.name} />
            <div className="overlay-name">
              <h3>{img.name}</h3>
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default Gallery;
